// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2VUxb","label":"LabeledBox_label__2cJRz"};